<template>
  <AffiliateLandingPage
    imageExt="png"
    imageName="YouDecide"
    routePath="youdecide"
    company="YouDecide"
  ></AffiliateLandingPage>
</template>

<script>
import AffiliateLandingPage from '@/components/Affiliate/AffiliateLandingPage.vue'

export default {
  components: {
    AffiliateLandingPage
  },
  name: 'YouDecideLandingPage'
}
</script>

<style></style>
